import { render } from "./PendingReviewTable.vue?vue&type=template&id=044b2f60&scoped=true"
import script from "./PendingReviewTable.vue?vue&type=script&lang=js"
export * from "./PendingReviewTable.vue?vue&type=script&lang=js"

import "./PendingReviewTable.vue?vue&type=style&index=0&id=044b2f60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044b2f60"]])

export default __exports__